import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from "@/helpers/authservice/jwt.service";
const timeout = 800000
/**
 * Service to call HTTP request via Axios
 */
const ApiMsEntregasService = {
  init() {
    Vue.use(VueAxios, axios)
    // VUE_APP_MS_ENTREGAS_URL is a brand-new env var added for the FIFO queue view - falls
    // back to the known dev URL if it isn't configured yet in the deployment, same reasoning
    // as the MS_APROBACION/MS_CUBICADOR backend fallbacks added alongside this feature.
    Vue.axios.defaults.baseURL = process.env.VUE_APP_MS_ENTREGAS_URL || "https://devmsentregamateriales.fluxsolar.cl/"
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  async get(resource, params = {}, responseType = undefined) {
    this.init()
    return await Vue.axios.get(`${resource}`, {
      params,
      timeout: timeout,
      responseType: responseType,
      headers: {
        'Authorization': `Bearer ${JwtService.getToken()}`
      }
    })
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  async post(resource, params) {
    this.init()
    return await Vue.axios.post(`${resource}`, params, {
      timeout: timeout,
      headers: {
        'Authorization': `Bearer ${JwtService.getToken()}`
      }
    }).catch(error => {
      return error
    })
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  async put(resource, params) {
    this.init()
    return Vue.axios.put(`${resource}`, params, {
      timeout: timeout,
      headers: {
        'Authorization': `Bearer ${JwtService.getToken()}`
      }
    }).catch(error => {
      return error
    })
  }
}

export default ApiMsEntregasService
